export const apps = [
  {
    section: "Shop",
    icon: "",
    items: [
      {
        name: "E-commerce Store",
        desc: "Complete online store with product listings and cart.",
        href: "/E-commerceStore",
        icon: "",
        badge: "Popular",
      },
      {
        name: "E-commerce Store",
        desc: "Complete online store with product listings and cart.",
        href: "/E-commercestudio",
        icon: "",
        badge: "Popular",
      },
      {
        name: "Fashion Boutique",
        desc: "Stylish fashion store with product showcase.",
        href: "/templates/fashion-boutique",
        icon: "",
      },
    ],
  },
  {
    section: "Photo Studios",
    icon: "",
    items: [
      {
        name: "Photostudio",
        desc: "Professional gallery for photographers.",
        href: "/photostudio",
        icon: "",
        badge: "New",
      },
      {
        name: "Studio Booking",
        desc: "Appointment system for photo studios.",
        href: "/templates/studio-booking",
        icon: "",
      },
    ],
  },
  {
    section: "Marketing",
    icon: "",
    items: [
      {
        name: "Digital Agency",
        desc: "Marketing agency showcase with services.",
        href: "/DigitalAgency",
        icon: "",
        badge: "Popular",
      },
      {
        name: "Campaign Landing",
        desc: "High-converting landing page for campaigns.",
        href: "/templates/campaign-landing",
        icon: "",
      },
    ],
  },
  {
    section: "Portfolio",
    icon: "",
    items: [
      {
        name: "Designer Portfolio",
        desc: "Creative portfolio for designers.",
        href: "/templates/designer-portfolio",
        icon: "",
      },
      {
        name: "Developer Showcase",
        desc: "Technical portfolio for developers.",
        href: "/templates/dev-showcase",
        icon: "",
        badge: "New",
      },
    ],
  },
  {
    section: "Languages",
    icon: "",
    items: [
      {
        name: "Language School",
        desc: "Online language learning platform.",
        href: "/templates/language-school",
        icon: "",
      },
      {
        name: "Translation Service",
        desc: "Professional translation business site.",
        href: "/templates/translation-service",
        icon: "",
        badge: "Popular",
      },
    ],
  },
  {
    section: "Schools",
    icon: "",
    items: [
      {
        name: "Educational Institute",
        desc: "Complete school website with class info.",
        href: "/templates/educational-institute",
        icon: "",
      },
      {
        name: "Online Course",
        desc: "E-learning platform with course catalog.",
        href: "/templates/online-course",
        icon: "",
        badge: "New",
      },
    ],
  },
  {
    section: "Supermarket",
    icon: "",
    items: [
      {
        name: "Grocery Store",
        desc: "Supermarket with online ordering system.",
        href: "/templates/grocery-store",
        icon: "",
        badge: "Popular",
      },
      {
        name: "Food Delivery",
        desc: "Restaurant and food delivery platform.",
        href: "/templates/food-delivery",
        icon: "",
      },
    ],
  },
];